import React, { useState, ReactNode } from 'react';
import { Menu, X } from 'lucide-react';

interface NavigationProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
}

interface NavLinkProps {
  page: string;
  children: ReactNode;
}

const Navigation: React.FC<NavigationProps> = ({ currentPage, setCurrentPage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const Logo = () => (
    <div className="flex items-center space-x-3">
      <img
        src="/api/placeholder/64/64"
        alt="Grace Technologies Logo"
        className="h-16 w-auto"
      />
      <div className="flex flex-col">
        <span className="text-xl font-bold">The Grace Technologies LLC</span>
        <span className="text-sm text-gray-200">Vision - Mission - Values</span>
      </div>
    </div>
  );

  const NavLink: React.FC<NavLinkProps> = ({ page, children }) => (
    <button
      onClick={() => setCurrentPage(page)}
      className={`hover:text-gray-200 ${currentPage === page ? 'font-semibold' : ''}`}
    >
      {children}
    </button>
  );

  return (
    <header className="fixed w-full bg-gradient-to-r from-purple-700 to-blue-500 text-white z-50">
      <nav className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-24">
          <div className="flex items-center">
            <button 
              onClick={() => setCurrentPage('home')}
              className="flex items-center"
            >
              <Logo />
            </button>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink page="home">Home</NavLink>
            <NavLink page="services">Services</NavLink>
            <NavLink page="about">About</NavLink>
            <NavLink page="contact">Contact</NavLink>
            <NavLink page="blog">Blog</NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-gray-200"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button onClick={() => { setCurrentPage('home'); setIsOpen(false); }} 
                className="block w-full text-left px-3 py-2 hover:bg-blue-500 rounded-md">
                Home
              </button>
              <button onClick={() => { setCurrentPage('services'); setIsOpen(false); }}
                className="block w-full text-left px-3 py-2 hover:bg-blue-500 rounded-md">
                Services
              </button>
              <button onClick={() => { setCurrentPage('about'); setIsOpen(false); }}
                className="block w-full text-left px-3 py-2 hover:bg-blue-500 rounded-md">
                About
              </button>
              <button onClick={() => { setCurrentPage('contact'); setIsOpen(false); }}
                className="block w-full text-left px-3 py-2 hover:bg-blue-500 rounded-md">
                Contact
              </button>
              <button onClick={() => { setCurrentPage('blog'); setIsOpen(false); }}
                className="block w-full text-left px-3 py-2 hover:bg-blue-500 rounded-md">
                Blog
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navigation;